import { postTranscriptionTranscribe } from '@/api/generated/transcription/transcription';

/**
 * Transcribes an audio file.
 * @param audioFile The audio file to transcribe.
 * @param language Optional language code (default: 'en').
 * @returns The transcription result.
 */
export const transcribeAudio = async (audioFile: File, language = 'en') => {
  try {
    return await postTranscriptionTranscribe({ audio: audioFile, language });
  } catch (error) {
    console.error('[Transcription Service] Error transcribing audio:', {
      error,
      fileName: audioFile.name,
      fileSize: audioFile.size,
      language,
      mimeType: audioFile.type,
    });
    throw error;
  }
};
